import PropTypes from 'prop-types'
import React from 'react'

const VARIANTS = {
  standard: '/images/HealthSherpa_for_Agents.png',
  white: '/images/HealthSherpa_for_Agents_white.png',
}

const HealthSherpaForAgentLogo = ({ variant }) => (
  <img src={VARIANTS[variant]} alt="HealthSherpa for Agents" width={225} />
)

HealthSherpaForAgentLogo.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
}

HealthSherpaForAgentLogo.defaultProps = {
  variant: 'standard',
}

export default HealthSherpaForAgentLogo
